import { HttpClient } from '@opallabs/api'
import handleError from '../handleError'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const requestAccess = ({ params, privacyGroupId }) =>
  HttpClient().post(`/privacy/v2/groups/${privacyGroupId}/members`, {
    data: params,
  })

const requestPrivacyGroupAccess =
  ({ message, privacyGroupId }) =>
  (dispatch, getState) => {
    const currentState = getState()
    const userId = currentState.me.id
    const opalId = currentState.current_opal_id

    const params = {
      attributes: {
        status: 'pending',
        note_comment: message,
      },
      relationships: {
        opal: {
          data: {
            id: opalId,
            type: 'opal',
          },
        },
        privacy_group: {
          data: {
            id: privacyGroupId,
            type: 'privacy_group',
          },
        },
        user: {
          data: {
            id: userId,
            type: 'user',
          },
        },
      },
      type: 'member',
    }

    return requestAccess({ params, privacyGroupId })
      .then((response) => dispatch(loadJsonApiEntities(response.data)))
      .catch((error) => {
        dispatch(
          handleError({
            error,
            type: 'requestPrivacyGroupAccess',
            component: 'weekView',
          })
        )
        console.log(error)
        throw error
      })
  }

export default requestPrivacyGroupAccess
